import { createContext } from 'react';

export const PassiveComponentContext = createContext(false);
